





















































































































































































































































































































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import ConfirmationBox from "@/components/ConfirmationBox.vue";

import Vue from "vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import { FilteringModel } from "@/services/filtering";
import CheckBox from "@/components/CheckBox.vue";
import eventBus from "@/services/eventBus";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import store, { BankStatementStore } from "@/modules/bankStatement/services/BankStatementStore";
import MoneyInput from "@/components/MoneyInput.vue";
import PartnerSearch from "../../partner/views/PartnerSearch.vue";
import Partner from "../../partner/models/Partner";
import BankInOutView from "../models/BankInOutView";

interface Data {
  filter: FilteringModel;
  sum: number;
  currSum: number;
  items: BankInOutView[];
  selectedItems: BankInOutView[];
  store: BankStatementStore;
  isDiffCurrency: boolean;
  selectedPartner: number;
}

interface Props {
  extraFilter: FilteringModel;
  partnerId: number;
  bankStatemnt: number;
  currency: string;
  title: string;
  isAmountChangeVisible: boolean;
  isEurBank: boolean;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
}

interface Methods {
  selected(item: BankInOutView): void;
  showDetails(item: BankInOutView): void;
  addToSummary(dataItem: BankInOutView): void;
  setItems(items: BankInOutView[]): void;
  generatePaymentItems(isOverride: boolean): void;
  amountChanged(item: BankInOutView): void;
  currAmountChanged(item: BankInOutView): void;
  statementAmountChanged(item: BankInOutView): void;
  setSummary(): void;
  partnerSelected(partner: Partner): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ApiSearchPage, CheckBox, ValidationError, MoneyInput, ConfirmationBox, PartnerSearch },

  props: {
    extraFilter: { type: Object as () => FilteringModel },
    bankStatemnt: { type: Number, default: 1 },
    partnerId: { type: Number, default: 1 },
    currency: { type: String, default: "" },
    isAmountChangeVisible: { type: Boolean, default: false },
    isEurBank: { type: Boolean, default: false },
    title: {
      type: String,
      default: "Számlaválogató (összes számla)",
    },
  },

  data: () => ({
    filter: new FilteringModel(),
    sum: 0,
    currSum: 0,
    items: [],
    selectedItems: [],
    store,
    isDiffCurrency: false,
    selectedPartner: 1,
  }),

  beforeMount() {
    this.filter = new FilteringModel();
    if (this.$props.extraFilter)
      this.filter = this.filter.fromFilter(this.$props.extraFilter.toObject());

    this.selectedPartner = this.$props.partnerId;
  },

  watch: {
    isDiffCurrency(){
      (this.$refs.apiSearch as any).refreshClick();
    }
  },

  methods: {
    partnerSelected(partner: Partner){
      (this.$refs.apiSearch as any).refreshClick();
    },

    selected(item: BankInOutView) {
      this.$emit("selected", item);
    },

    showDetails(item: BankInOutView) {
      item.selected = !item.selected;
    },

    addToSummary(dataItem: BankInOutView) {
      eventBus.$emit("bank-in-out-view:get-items");
      if (!dataItem.added) {
        dataItem.added = true;
      } else {
        dataItem.added = false;

        const selectedItem = this.selectedItems.find(x => x.invNo == dataItem.invNo && x.code == dataItem.code);
        if (selectedItem) {
          const index = this.selectedItems.indexOf(selectedItem);
          this.selectedItems.splice(index, 1);
        }
      }

      this.setSummary();
    },

    setSummary(){
      let sum = 0;
      let currSum = 0;

      //VIZT351: a kivonat tétel irányához képest előjelezünk: az azonos irányú számla növeli,
      //az ellentétes irányú (jóváíró/sztornó) számla csökkenti a válogatott összeget
      const itemCrediting = this.store.bankDocument.bankStatementItem.crediting;

      this.items.forEach((x: BankInOutView) => {
        if (x.added){
          const sign = x.isCrediting == itemCrediting ? 1 : -1;
          sum += sign * Math.abs(x.total);
          currSum += sign * Math.abs(x.statementTotal);
        }
      });

      if (this.store.bankStatement.currency != "HUF"){
        eventBus.$emit("update-curr-sum", currSum);
      } else {
        eventBus.$emit("update-sum", sum);
      }
    },

    generatePaymentItems(isOverride) {
      this.$emit("generate-payments", {
        selectedItems: this.selectedItems,
        partnerID: this.$props.partnerId,
        isOverrideAmount: isOverride
      });

      // SAKT179: a kijelölést csak akkor ürítjük, ha a generálás ténylegesen elindul.
      // Ha a szülő az "összeg nem egyezik" kérdést teszi fel (isAmountChangeVisible), a kijelölés
      // és az összesítő marad, és a válasz utáni hívásnál ürítünk. Korábban már az első
      // kattintásnál kiürült a kijelölés (setSummary nélkül), így a pipák eltűntek, a gomb
      // inaktív lett, az összesítő viszont a régi értéken állt.
      // A szülő a kérdést az emit kezelőjében szinkron állítja, a prop a következő tickben frissül.
      this.$nextTick(() => {
        if (this.isAmountChangeVisible) return;

        this.selectedItems.forEach(x => x.added = false);
        this.selectedItems = [];
        this.setSummary();
      });
    },

    setItems(items) {
      this.items = items;

      this.items.forEach(x => {
        if (this.isEurBank){
          const currency = store.bankDocument.bankStatementItem.invCurrency;
          if (x.invCurrency != currency) {
            x.statementTotal = Math.round(x.currTotal * x.exchangeRate / store.bankDocument.bankStatementItem.exchangeRate * 100) / 100;
          } else {
            x.statementTotal = x.currTotal;
          }
        } else {
          x.statementTotal = x.total;
        }
      });

      const newSelected = items.filter((x) => x.added);
      newSelected.forEach((element) => {
        if (!this.selectedItems.some(x => x.code == element.code && x.invNo == element.invNo)) {
          this.selectedItems.push(element);
        }
      });

      if (this.selectedItems.length > 0){
        this.selectedItems.forEach((element) => {
          const item = items.find(x => x.invNo == element.invNo && x.code == element.code);
          if (item) {
            item.added = true;
          }
        });
      }
    },

    amountChanged(item){
      item.currTotal = Math.round(item.total / item.exchangeRate * 100) / 100;

      if (this.isEurBank) {
        const currency = store.bankDocument.bankStatementItem.invCurrency;
        if (currency != item.invCurrency) {
          item.statementTotal = Math.round(item.currTotal * item.exchangeRate / store.bankDocument.bankStatementItem.exchangeRate * 100) / 100;
          } else {
            item.statementTotal = item.currTotal;
          }
        } else {
          item.statementTotal = item.total;
      }

      this.setSummary();
    },

    currAmountChanged(item){
     item.total = Math.round(item.currTotal * item.exchangeRate * 100) / 100;

     if (this.isEurBank) {
        const currency = store.bankDocument.bankStatementItem.invCurrency;
        if (currency != item.invCurrency) {
          item.statementTotal = Math.round(item.currTotal * item.exchangeRate / store.bankDocument.bankStatementItem.exchangeRate * 100) / 100;
          } else {
            item.statementTotal = item.currTotal;
          }
        } else {
          item.statementTotal = item.total;
      }

     this.setSummary();
    },

    statementAmountChanged(item) {
      if (this.isEurBank) {
        const currency = store.bankDocument.bankStatementItem.invCurrency;
        if (item.invCurrency != currency) {
          item.currTotal = Math.round(item.statementTotal * store.bankDocument.bankStatementItem.exchangeRate / item.exchangeRate * 100) / 100;
          item.total = item.currTotal * item.exchangeRate;
        } else {
          item.currTotal = item.statementTotal;
          item.total = item.currTotal * item.exchangeRate;
        }
      } else {
        item.currTotal = item.statementTotal;
        item.total = item.currTotal;
      }

      this.setSummary();
    }
  },

  computed: {
    columns: function() {
      return [
            {
              cell: "statementDetailsButtonTemplate",
              filterable: false,
              income: "isCrediting",
            },
            { field: "k2DInvNo", title: "Számlaszám", income: "isCrediting" },
            { field: "outerInvNo", title: "Külső számlaszám", income: "isCrediting" },
            {
              cell: "total",
              field: "total",
              title: "Összeg",
              type: ColumnType.Money,
              filterable: false
            },
            {
              cell: "currTotal",
              field: "currTotal",
              title: "Összeg (dev)",
              type: ColumnType.Money,
              filterable: false
            },
            {
              cell: "statementTotal",
              field: "statementTotal",
              title: "Összeg (bank)",
              type: ColumnType.Money,
              filterable: false
            },
            {
              cell: "toPayment",
              field: "toPayment",
              title: "Szla. nyitott rész",
              type: ColumnType.Money,
            },
            {
              cell: "currToPayment",
              field: "currToPayment",
              title: "Szla. nyitott rész (dev)",
              type: ColumnType.Money,
            },
            { field: "invCurrency", title: "Pénznem" },
            { field: "bodyNo", title: "Alvázszám" },
            { field: "invDate", title: "Számla kelte", type: ColumnType.Date, range: true, headerClass: "date-min-width", fieldClass: "date-min-width" },
            { field: "shipDate", title: "Teljesítés dátuma", type: ColumnType.Date, range: true, headerClass: "date-min-width", fieldClass: "date-min-width" },
            { field: "remark1", title: "Megjegyzés" },
            { field: "finalRemark", title: "Végszámla megjegyzés", cell: 'finalRemark', filterable: false, sortable: false },
            {
              cell: "selectButton",
              filterable: false,
            },
          ];
    },

    url() {
      return `bankinout/dto/search/${this.selectedPartner}/${this.$props.currency}/${this.$props.bankStatemnt}/${this.isDiffCurrency}`;
    },
  },
});
